import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';
import { GrausInstrucaoService } from 'src/app/services/graus-instrucao/graus-instrucao.service';
import { GrausInstrucao } from 'src/app/core/graus-instrucao';

@Component({
  selector: 'combo-grau-instrucao',
  templateUrl: './combo-grau-instrucao.component.html',
  styleUrls: ['./combo-grau-instrucao.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class ComboGrauInstrucaoComponent implements OnInit {

  @ViewChild('comboGrauInstrucao', {static: false}) comboGrauInstrucao;

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;

  @Output() valorChange = new EventEmitter();

  dados = [];
  data: any = {};

  constructor(private grausInstrucaoService: GrausInstrucaoService) {
  }

  ngOnInit(): void {
    this.data = Date.now();

    // Carrega graus de instrução dinamicamente do serviço
    this.grausInstrucaoService.getAll().subscribe((graus: GrausInstrucao[]) => {
      this.dados = graus;
      this.preencherCombo();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.preencherCombo();
  }

  private preencherCombo(){
    if (this.selecionado && this.dados.length) {
      if (typeof this.selecionado === 'number' || typeof this.selecionado === 'string') {
        this.selecionado = _.find(this.dados, { id: this.selecionado});
      }
    }
  }

  onValorChange(registro: any) {
    this.valorChange.emit(registro);
    this.preencherCombo();
  }

}
